exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".heroicon-user .heroicon-outline{fill:#303034}.heroicon-user .heroicon-component-fill{fill:#fff}.heroicon-user .heroicon-component-accent{fill:#919495}.heroicon-user .heroicon-shadows{fill:#303034;opacity:.4}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-3dcd98d9","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/components/Icons/UserIcon.vue
// module id = qoeP
// module chunks = 0